exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vdp-datepicker input{border:1px solid #ced4da;padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.25rem;color:#495057}.history-item-bag{display:flex;align-items:flex-start;padding:10px 0}.history-item-bag .center{flex:0.5}.history-item-bag .left{flex:1}.history-item-bag .right{flex:4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ef93e26","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/complaints/ComplaintsEdit.vue
// module id = 877
// module chunks = 0